export { default as InvolvedPeople } from "./InvolvedPeople";
